import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterService } from '../../@core/services/master.service'; 

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private masterService: MasterService) {}

 getAllProjects(userId?: number): Observable<any> {
  const payloadData: any = {
    action: "SELECT_PROJECTS"
  };

  if (userId) {
    payloadData.assigned_to_id = userId;
  }

  return this.masterService.manage_projects(payloadData);
}
//  getProjectView(payload: { project_id: number; version_id: number }): Observable<any> {
//     return this.masterService.get_Projectview(payload);
//   }
//  get_ProjectviewWithProjectIdAndVersionId(payload): Observable<any> {
//      return this.masterService.get_Projectview(payload);
//   }

}
